// npm
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { getSessionData, getExamData } from "redux/reducers/selectors";
import { getClientSessionData } from "redux/reducers/session/selectors";
import { getOrgId } from "redux/reducers/session/client/selectors";
import { getAllowTextSelection } from "redux/reducers/exam/selectors";

// xams-utils
import { check } from "@xams-utils/check-types";

// material-ui
import Typography from "@material-ui/core/Typography";

// utils
import { htmlToReact } from "utils/html-to-react";

const getSpaceOutReg = (text) => {
    if (!check.nonEmptyString(text)) {
        return text;
    }

    try {
        if (text.indexOf("&lt;") === -1 && text.indexOf("&gt;") === -1) {
            return text;
        }

        const regex_sb = /(\S)((&gt;|&lt;))/gm;
        const regex_sa = /((&gt;|&lt;))(\S)/gm;

        return text
            .replace(regex_sb, "$1 $3")
            .replace(regex_sa, "$1 $3")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">");
    } catch (e) {
        return text;
    }
};

const isHtmlText = (
    text // may need stricter check
) => {
    if (!check.string(text)) {
        return false;
    }
    const openTagIndex = text.indexOf("<");
    return openTagIndex !== -1 && text.indexOf(">", openTagIndex);
};

let MaterialText = ({
    children: text,
    component,
    orgId,
    allowTextSelection,
    forceTextSelection,
    ...typographyProps
}) => {
    const isHtml = isHtmlText(text);
    const container = component ? component : isHtml ? "div" : undefined; // nested <p> not allowed

    const spaceOut = orgId === 29 || orgId === 15 || orgId === 22;
    const _text = spaceOut ? getSpaceOutReg(text) : text;

    const finalText = isHtml ? htmlToReact.parse(_text) : _text;

    // forceTextSelection (used by HighlightableText) makes the text selectable so it can be
    // highlighted, even on exams that otherwise block selection - copy/cut/paste stay blocked
    // whenever the exam itself doesn't allow text selection
    const style = allowTextSelection || forceTextSelection ? {} : { userSelect: "none" };

    const disableClipboard = !allowTextSelection;

    const clipboardProps = disableClipboard
        ? {
              onCopy: (e) => e.preventDefault(),
              onCut: (e) => e.preventDefault(),
              onPaste: (e) => e.preventDefault(),
          }
        : {};

    return (
        <Typography
            component={container}
            {...typographyProps}
            {...clipboardProps}
            style={style}
            aria-live="polite"
            aria-atomic="true"
        >
            {finalText}
        </Typography>
    );
};

MaterialText.propTypes = {
    children: PropTypes.string.isRequired,
    forceTextSelection: PropTypes.bool,
};

const mapStoreToProps = (store) => {
    const sessionData = getSessionData(store);
    const clientSessionData = getClientSessionData(sessionData);
    const orgId = getOrgId(clientSessionData);

    const examData = getExamData(store);
    const allowTextSelection = getAllowTextSelection(examData);

    return {
        orgId,
        allowTextSelection,
    };
};

MaterialText = connect(mapStoreToProps)(MaterialText);

export { MaterialText };
